/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import ScenarioBox from '../scenarios/ScenarioBox.react';
import FlowSimpleList from '../flows/FlowSimpleList.react';
import AppliedFlowDescription from '../flows/AppliedFlowDescription.react';
import { Organisation, Scenario } from '../../common/types/types';

interface ApplyScenarioMutationProps {
 args?: object;
 organisation: Organisation;
 relay?: object;
 scenario: Scenario;
 selectedChannels?: unknown[];
 callbackOnSave?: string | null;
}

export default class ApplyScenarioMutation extends Relay.Mutation<ApplyScenarioMutationProps> {

    static propTypes = {
        args: PropTypes.object,
        organisation: PropTypes.object.isRequired,
        relay: PropTypes.object,
        scenario: PropTypes.object.isRequired,
        selectedChannels: PropTypes.array,
        callbackOnSave: PropTypes.string,
    };

    getMutation() {
        return Relay.QL`mutation {applyScenario}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on ApplyScenarioPayload {
                clientMutationId,
                updatedOrganisation {
                    id,
                    name,
                    payPlan,
                    channels(first: 100, deleted: false) {
                        edges {
                            node {
                                name,
                                type,
                                confidential,
                                cachingStatus,
                                activated,
                                metadata,
                                channelDef_id,
                                channelDef {
                                    id,
                                    realId,
                                    icon,
                                    name,
                                    metadata,
                                    addType,
                                    state,
                                    hasOwnPlugin,
                                    metadata,
                                    canBeAddedOnce
                                },
                                id,
                                realId,
                                organisation_id,
                                enabled,
                                lastCachingRefresh,
                                cachingInProgressJob,
                            }
                        }
                    },
                    ${FlowSimpleList.getFragment('organisation')},
                    usedScenarios(first: 100) {
                        edges {
                            node {
                                id,
                                realId,
                                scenario, {
                                    id,
                                    realId,
                                    ${ScenarioBox.getFragment('scenario')}
                                }
                            }
                        }
                    }
                },
                channelDefsToAdd {
                    id,
                    realId,
                    addType,
                    name,
                    icon,
                },
                channelsToFix {
                    id,
                    realId,
                    organisation_id,
                    name,
                    activated,
                    confidential,
                    cachingStatus,
                    lastCachingRefresh,
                    cachingInProgressJob,
                    enabled,
                    channelDef {
                        id,
                        realId,
                        icon,
                        name,
                        addType,
                        metadata,
                        state,
                        hasOwnPlugin,
                        metadata,
                        canBeAddedOnce
                    }
                },
                channelsWithConfidentialMode {
                    id,
                    organisation_id,
                    realId,
                    name,
                    activated,
                    confidential,
                    cachingStatus,
                    lastCachingRefresh,
                    cachingInProgressJob,
                    enabled,
                    channelDef {
                        id,
                        realId,
                        icon,
                        name,
                        metadata,
                        addType,
                        state,
                        hasOwnPlugin,
                        metadata,
                        canBeAddedOnce
        }
                },
                channelsToSelect {
                    channelDef {
                        id,
                        realId,
                        icon,
                        name,
                        metadata,
                        addType,
                        state,
                        hasOwnPlugin,
                        metadata,
                        canBeAddedOnce
                    },
                    channels {
                        id,
                        realId,
                        name,
                    },
                }
                resultLinks {
                    channelDef {
                        id,
                        realId,
                        name,
                        icon,
                        connectRequirement,
                        hasOwnPlugin,
                    },
                    sourceDef {
                        id,
                        realId,
                        name,
                    },
                    linksToSourceDef,
                    url
                },
                errors,
                flows {
                    id,
                    realId,
                    organisation_id,
                    activated,
                    ${AppliedFlowDescription.getFragment('flow')}
                    flowDef {
                        id,
                        realId,
                        name,
                        type,
                        flowStepDefs(first: 100) {
                            edges {
                                node {
                                    id,
                                    type,
                                    name,
                                }
                            }
                        },
                        flowChannelDefs(first:100) {
                            edges {
                                node {
                                    id,
                                    name,
                                }
                            }
                        }
                    },
                    options,
                    configOptions,
                    selectedChannels,
                    enabled
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            args: this.props.args ? JSON.stringify(this.props.args) : null,
            scenario_id: this.props.scenario.id,
            organisation_id: this.props.organisation.id,
            selectedChannels: this.props.selectedChannels,
            callbackOnSave: this.props.callbackOnSave,
        };
    }
}
